// extracted by mini-css-extract-plugin
export var contentBody = "_94-9";
export var headerImage = "_94-2";
export var imageButton = "_94-7";
export var imageButtonIcon = "_94-8";
export var imageHeader = "_94-4";
export var imageHeaderText = "_94-5";
export var imageOverlay = "_94-3";
export var imageTitle = "_94-6";
export var imageWrapper = "_94-1";
export var taskList = "_94-a";
export var widget = "_94-0";